import React, { useState, useEffect } from 'react';
import {
    Input,
    InputGroup,
    Stack,
    Breadcrumb,
    Divider,
    Panel,
    Container,
    Table,
    Button,
    DatePicker,
    Whisper,
    Tooltip,
    IconButton,
    SelectPicker,
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import QrcodeIcon from '@rsuite/icons/Qrcode';
import globalIP from '@/GlobelIP';
import { Link, useLocation } from 'react-router-dom';
import ugr from '@/UGRoute';
const { Column, HeaderCell, Cell } = Table;
const FinalFair = () => {
    const ip = globalIP;
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const selectedItems = searchParams.get('selectedItems') || '';
    const selectedItemsArray = selectedItems.split(',');

    const [data1234, setData1234] = useState([]);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const response = await fetch(`${ip}/api/products?populate=*`);
        const json = await response.json();
        const filtereddData = json.data.filter(item => selectedItemsArray.includes(String(item.id)));
        setData1234(filtereddData);
    };

    return (
        <>
            <Container className='main'>
                <Stack className="table-toolbar" justifyContent="space-between">
                    <Stack direction='column' alignItems='flex-start'>
                        <Stack direction='column' alignItems='flex-start' >
                            <h3 className="title">Remove From Fair</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <Link to={`/${ugr}/dashboard`}>
                                        Home</Link></Breadcrumb.Item>
                                <Breadcrumb.Item active>Create</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>
                        <Stack spacing={5}>
                            <Stack direction='column' alignItems='flex-start' >
                                <label>QR Size</label>
                                <SelectPicker data={[]} />
                            </Stack>


                        </Stack>
                    </Stack>
                    <Stack direction='column' alignItems='flex-end' spacing={30} style={{ marginBottom: '-27px' }}>
                        <Stack direction='row' spacing={5}>
                            <InputGroup inside >
                                <Input placeholder="Search" />
                                <InputGroup.Addon>
                                    <SearchIcon />
                                </InputGroup.Addon>
                            </InputGroup>

                        </Stack>
                        <Stack spacing={10}>
                            <IconButton appearance="primary" color="cyan" icon={<QrcodeIcon />}>
                                Print
                            </IconButton>
                            <Button appearance='subtle' active>Fair Products</Button>

                        </Stack>
                    </Stack>
                </Stack>
                <Divider className='divide' />
                <div className="row">
                    <Panel>
                        <Table height={420} data={data1234}
                            rowHeight={60}
                            rowKey="id"
                            bordered
                            cellBordered
                            wordWrap
                        >
                            <Column width={80} align='center'>
                                <HeaderCell><b>Alias Code</b></HeaderCell>
                                <Cell dataKey={'attributes.ProductId'} />
                            </Column>

                            <Column width={160} align='center'>
                                <HeaderCell><b>Image</b></HeaderCell>
                                <Table.Cell>
                                    {(rowData) => {
                                        // Define a function to show the enlarged image on hover
                                        const renderTooltip = (imageSrc) => (
                                            <Tooltip style={{ backgroundColor: 'white' }}>
                                                <img
                                                    src={imageSrc}
                                                    alt="Product Image"
                                                    style={{ width: 400, height: 'auto' }}
                                                />
                                            </Tooltip>
                                        );

                                        return (
                                            <Whisper trigger="hover" placement="right" speaker={renderTooltip(`${ip}${rowData.attributes.CoverImage.data.attributes.url}`)}>
                                                <img
                                                    src={`${ip}${rowData.attributes.CoverImage.data.attributes.url}`}
                                                    alt="Product Image"
                                                    style={{ width: 50, height: 50, marginTop: '-16px' }}
                                                />
                                            </Whisper>
                                        );
                                    }}
                                </Table.Cell>
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Product Name</b></HeaderCell>
                                <Cell dataKey={'attributes.ProductName'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Description</b></HeaderCell>
                                <Cell dataKey={'attributes.Description'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Dimension</b></HeaderCell>
                                <Cell>
                                    {(rowData) => {
                                        const { Length, Width, Height, SizeUnit } = rowData.attributes;
                                        const sizeInfo = `${Length} x ${Width} x ${Height} ${SizeUnit}`;
                                        return sizeInfo;
                                    }
                                    }
                                </Cell>
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Finish</b></HeaderCell>
                                <Cell dataKey={'attributes.FinishName'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Color</b></HeaderCell>
                                <Cell dataKey={'attributes.ColorName'} />
                            </Column>
                            <Column width={180} align='center'>
                                <HeaderCell><b>CBM</b></HeaderCell>
                                <Cell dataKey={'attributes.cbm'} />
                            </Column>
                            <Column width={180} align='center'>
                                <HeaderCell><b>Nt. Wt.</b></HeaderCell>
                                <Cell dataKey={'attributes.NetWeight'} />
                            </Column>

                        </Table>

                    </Panel>
                </div>
                <Stack className="copyright" justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
                    <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERPDaddy Software Solution.</a></p>
                </Stack>
            </Container>
        </>
    )
}

export default FinalFair;